import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { fullName } from 'utils/full-name';

interface ResoruceRequestAssigneeMessageProps {
  changedObject: { firstName: string; lastName: string };
  causerName: string;
  keyForString: string;
}
export const ResoruceRequestAssigneeMessage: FC<ResoruceRequestAssigneeMessageProps> =
  ({
    changedObject = { firstName: '', lastName: '' },
    causerName = '',
    keyForString = '',
  }) => {
    const assigneeFullName = fullName(changedObject);

    return (
      <FormattedMessage
        id={keyForString}
        values={{
          changedByUserName: causerName ?? '',
          assignee: assigneeFullName,
        }}
      />
    );
  };
